export default {
  camelCaseToUnderscore(string) {
    return string.replace(/\.?([A-Z])/g, (_x, y) => `_${y.toLowerCase()}`);
  },

  camelCaseToKebabCase(string) {
    return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
  },

  underscoreToCamelCase(string) {
    return string.replace(/_([a-z])/g, g => g[1].toUpperCase());
  },
};
